<template>
  <div id="storeTest">storeTest</div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
export default {
  name: "storeTest",
  computed: {
    // computed 里面的值必须要在 html 或 函数体 中调用不然不会执行
    ...mapState(["test", "test2"]), // 这一步之后可以在此组件内通过 this.test 的方法进行数据调用
    ...mapGetters(["newTestName"])
  },
  data() {
    return {};
  },
  mounted() {
    console.log("this.test", this.test, this.newTestName);
    this.amendValue();
  },
  methods: {
    ...mapMutations(["amendState"]),
    amendValue() {
      this.amendState([{ test: "xiaolizi" }, { test2: "xiaolizi2" }]); // 这一步可以动态更改 stroe-state 里面的值，详细注释看 store - index.js
    }
  }
};
</script>
<style lang='scss' scoped>
#storeTest {
  border: 1px solid blue;
}
</style>


// WEBPACK FOOTER //
// src/views/test/ms-storeTest.vue